import React from "react";

//UI Material
import { Card, Divider, Grid, Stack, Typography } from "@mui/material";

export default function StockoutInfo({ data }) {
  const getTaxesAmount = () => {
    try {
      return (
        (data.quantity * Number(data.costPerSoldUnit) * data.taxesPercentage) / 100
      );
    } catch (e) {
      console.error(e);
      return 0;
    }
  };

  const getTotalAmount = () => {
    try {
      return data.taxesIncluded
        ? data.costPerSoldUnit * data.quantity
        : data.costPerSoldUnit * data.quantity + getTaxesAmount();
    } catch (e) {
      console.error(e);
      return 0;
    }
  };

  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container sx={{ padding: "20px" }} spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h6" fontWeight="bold">
            Información del movimiento
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Información principal de esta salida
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Nombre del ítem
            </Typography>
            <Typography variant="body2">{data.name}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Identificador del ítem
            </Typography>
            <Typography variant="body2">{data.itemId}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Cantidad del ítem
            </Typography>
            <Typography variant="body2">{data.quantity}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Razón de salida del ítem
            </Typography>
            <Typography variant="body2">{data.reason}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Información sobre precio de venta/salida ítem
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Precio unitario de venta/salida del ítem
            </Typography>
            <Typography variant="body2">
              {`${data.currency} ${data.costPerSoldUnit || "Sin especificar"}`}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Impuestos unitario del ítem
            </Typography>
            <Typography variant="body2">{`${data.currency} ${
              getTaxesAmount() / data.quantity
            } (${data.taxesPercentage}% ${
              data.taxesIncluded
                ? "incluído en precio unitario"
                : "no incluído en precio unitario"
            })`}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Monto por impuestos
            </Typography>
            <Typography variant="body2">{`${
              data.currency
            } ${getTaxesAmount()}`}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Monto total de venta/salida
            </Typography>
            <Typography variant="body2">
              {`${data.currency} ${getTotalAmount()}`}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
}
